import { ReactNode } from "react";

/** Mono, uppercase section label ("PROFILE PICTURE", "USER DETAILS", …). */
export const UserSectionHeading = ({ children }: { children: ReactNode }) => (
  <h3 className="tw-font-mono tw-text-xs tw-font-medium tw-uppercase tw-tracking-widest tw-text-muted-foreground">
    {children}
  </h3>
);

interface UserSectionProps {
  title: string;
  children: ReactNode;
}

/** One headed block of the drawer body. */
export const UserSection = ({ title, children }: UserSectionProps) => (
  <section className="tw-flex tw-flex-col tw-gap-4">
    <UserSectionHeading>{title}</UserSectionHeading>
    {children}
  </section>
);

/** Single-column drawer body shared by the user Register, Edit and Details views. */
const UserFormLayout = ({ children }: { children: ReactNode }) => (
  <div className="tw-flex tw-flex-col tw-gap-8 tw-p-6">{children}</div>
);

export default UserFormLayout;
